/**
 * Helper functions for localStorage: get, set, remove
 */

export function setLocalStorage(key, value) {
  try {
    window.localStorage.setItem(key, JSON.stringify(value));
  } catch (e) {
    // handle error if needed
  }
}

export function getLocalStorage(key, defaultValue = null) {
  try {
    const item = window.localStorage.getItem(key);
    return item ? JSON.parse(item) : defaultValue;
  } catch (e) {
    return defaultValue;
  }
}

export function removeLocalStorage(key) {
    try {
        window.localStorage.removeItem(key);
    } catch (e) {
        // handle error if needed
    }
}